const config = {
    API_URL: 'https://www.escapegamehelper.ovh/api/',
}
export default config;
